// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import StoreListsDetailsDataState from "@store/Framework/Store/Data/StoreListDetails/StoreListDetailsState";
import { StoreListCustomersCollectionModel } from "@store/Framework/Types/ApiModels";
import { GetStoreListCustomersApiParameter } from "@store/Services/StoreListService";
import { Draft } from "immer";

const initialState: StoreListsDetailsDataState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const actions = {
    "Data/StoreListDetails/BeginLoadStoreListCustomers": (
        draft: Draft<StoreListsDetailsDataState>,
        action: { parameter: GetStoreListCustomersApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Data/StoreListDetails/Reset": () => {
        return initialState;
    },
    "Data/StoreListDetails/CompleteLoadStoreListCustomers": (
        draft: Draft<StoreListsDetailsDataState>,
        action: { parameter: GetStoreListCustomersApiParameter; result: StoreListCustomersCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.result,
            collection => collection.storeListCustomerCollection!,
        );
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreListsDetailsDataActions = Parameters<typeof reducer>[1];
export default reducer;
